<template>
  <b-modal
    id="annonce-payment-promise-modal"
    class="payment-promise-full-screen-modal"
    header-class="payment-promise-modal-header"
    ref="modal"
    centered
    no-close-on-esc
    no-close-on-backdrop
  >

    <template #modal-header="{ close }">
      <div  class="payment-promise-modal-header-content step4 w-100">
        <img :src="require(`@/assets/images/b122/img-watcher-right.png`)" class="payment-promise-modal-img" >
        <div class="payment-promise-container h-100">
          <h1 class="page-title mt-4 ml-4 payment-promise-modal-subtitle" v-html="isRewardEdit ? $t('payment.validation.edit.title') : $t('payment.validation.publish.title')"></h1>
        </div>
      </div>
    </template>

    <div>
      <div class="d-flex mb-4">
        <b-form-checkbox
          class="mr-2"
          id="confirmationChecked"
          v-model="isChecked">
        </b-form-checkbox>

        <p v-html="$t('payment.validation.content')"></p>
      </div>

      <p class="main-grey-medium-color" v-html="$t('payment.validation.explanation')"></p>

    </div>


    <template #modal-footer="{ ok, cancel, hide }">
      <div class="w-100 d-flex">
        <b-button  class="w-100 mr-4" variant="secondary"  @click="handleCancel">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{$t('Back')}}</span>
          </div>
        </b-button>
        <b-button  class="w-100" variant="primary"  @click="handleOk($event)" :disabled="!isChecked">
          <div class="d-flex justify-content-center">
            <span class="align-self-center mt-small-px">{{isRewardEdit ? $t('Validate') : $t('Publish')}}</span>
          </div>
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      isChecked: false,
    };
  },

  props:{
    isRewardEdit:{
      default: false,
      type: Boolean
    }
  },

  emits: [
    'publish', 'close'
  ],

  methods: {

    async handleOk(e) {
      e.preventDefault()
      this.$emit('publish')
    },

    handleCancel(){
      this.$emit('close')
    }
  },
};
</script>

<!-- not scoped car modal --><style>

#annonce-payment-promise-modal .modal-header{
  background-color: var(--main-black-light) !important;
  padding-bottom: 0px;
}

#annonce-payment-promise-modal .modal-content,
#annonce-payment-promise-modal .modal-body,
#annonce-payment-promise-modal .modal-footer{
  background-color: var(--main-black-dark);
}

.payment-promise-modal-subtitle{
  font-size: 24px;
}

.payment-promise-modal-img{
  max-width: 200px;
}
#annonce-payment-promise-modal .payment-promise-modal-header-content {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border-bottom: none;
}


.payment-promise-modal-img {
  max-width: 200px;
  min-width: 100px;
  z-index: 1;
}

#annonce-payment-promise-modal .modal-annonce-text{
  color: var(--main-grey-medium);
}

.payment-promise-modal-header {
  background-color: var(--main-black-medium) !important;
  position: relative;
  margin-top: -20px;
  margin-right: -20px;
  margin-left: -20px;
}

.payment-promise-container {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  flex-direction: column;
}

@media (min-width: 992px) {
  .payment-promise-container {
    flex-direction: column;
  }
}

@media (max-width: 991px) {
  .payment-promise-container img {
    order: 2;
    align-self: center;
  }
  .payment-promise-container {
    text-align: center;
  }
}

#annonce-payment-promise-modal .modal-content {
  overflow: hidden;
  border-radius: 30px;
}

.payment-promise-full-screen-modal .modal-dialog {
  max-width: 100%;
  margin: 0;
}
.payment-promise-full-screen-modal .modal-content {
  height: auto;
  border-radius: 30px;
}

@media (max-width: 767px) {
  #annonce-payment-promise-modal .modal-content {
    display: flex;
    overflow: auto;
  }
  #annonce-payment-promise-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }

  #annonce-payment-promise-modal .modal-body{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  #annonce-payment-promise-modal .modal-dialog {
    max-width: 100%;
    margin: 0;
  }
  #annonce-payment-promise-modal .modal-header {
    padding-top: 0px;
  }
  .payment-promise-modal-img {
    margin-top: 20px;
    align-self: end;
  }
  .payment-promise-modal-subtitle {
    margin-top: 6px !important;
    margin-left: 0px !important;
  }
  #annonce-payment-promise-modal .modal-content {
    margin: 8px;
  }
  #annonce-payment-promise-modal .modal-annonce-text, #annonce-payment-promise-modal .payment-promise-container {
    padding: 10px;
  }
  #annonce-payment-promise-modal .payment-promise-modal-img {
    max-width: 100px;
  }
}

@media (max-height: 852px) {
  #annonce-payment-promise-modal .modal-content {
    overflow: auto;
  }
  .title-step4{
    font-size: 24px!important;
  }

  .payment-promise-modal-subtitle{
    font-size: 18px;
  }
  .payment-promise-modal-header-content, #annonce-payment-promise-modal .modal-annonce-text, .payment-promise-container {
    padding: 2px;

  }
}





</style>



// WEBPACK FOOTER //
// src/views/annonce/AnnoncePaymentPromiseModal.vue